module.exports = __webpack_public_path__ + "img/Group 118.4bf00b21.jpg";